import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { Box, Card, LinearProgress, Typography } from '@mui/material';
import { useHistory } from 'react-router';

import { selectUser } from 'entities/user/selectors';

import { useSteps } from './useSteps';
import { Step } from './Step';

const OnboardingTrackerPage = () => {
  const steps = useSteps();
  const user = useSelector(selectUser);

  const history = useHistory();

  if (!user?.organization) {
    return <LinearProgress />;
  }

  if (!user.organization?.isNonprofit()) {
    history.replace('/');
  }

  const onboardingComplete = steps.every((step) => step.checked);

  return (
    <>
      <Helmet title="Organization Onboarding Overview" />

      <Box maxWidth={968} margin="0 auto">
        <Typography variant="h1" fontSize={24} fontWeight={400} textAlign="center" mt={10} mb={2}>
          Organization Onboarding {onboardingComplete ? 'Completed' : 'in Progress'}
        </Typography>
        <Typography
          fontSize={14}
          fontWeight={400}
          textAlign="center"
          color="GrayText"
          mb={8}
          maxWidth={600}
          ml="auto"
          mr="auto"
        >
          {onboardingComplete ? (
            <>
              Congratulations! Your organization has successfully completed the onboarding process.
              You&apos;re now fully equipped to maximize the benefits of our platform. Welcome to
              the community!
            </>
          ) : (
            <>
              Complete Onboarding to Maximize Your Nonprofit&apos;s Profile and Access Key
              Opportunities from Company Partnerships! 🎉
            </>
          )}
        </Typography>

        <Card variant="outlined" style={{ padding: '24px 16px' }}>
          {steps.map((step, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Step key={i} step={step} index={i + 1} isLast={i + 1 === steps.length} />
          ))}
        </Card>
      </Box>
    </>
  );
};

export default OnboardingTrackerPage;
